module.exports = __webpack_public_path__ + "img/CM-MC-25-Audi-Modern.c6b9abd9.jpg";